export default __webpack_public_path__ + "static/media/all_months.027e048b.jpg";